import React from 'react';
import PropTypes from 'prop-types';
import { stripesConnect } from '@folio/stripes/core';

import StaffUserCreate from '../views/StaffUserCreate/StaffUserCreate';

class StaffUserCreateContainer extends React.Component {
  static manifest = Object.freeze({
    uniquenessValidator: {
      type: 'okapi',
      records: 'users',
      accumulate: 'true',
      path: 'users',
      fetch: false,
    },
    records: {
      type: 'okapi',
      path: 'users',
      records: 'users',
      accumulate: 'true',
      fetch: false,
    },
    perms: {
      type: 'okapi',
      path: 'perms/users',
      records: 'permissionUsers',
      DELETE: {
        path: 'perms/users/%{permUserId}',
      },
      POST: {
        path: 'perms/users',
      },
    },
    permissions: {
      type: 'okapi',
      records: 'permissions',
      path: 'perms/permissions?length=1000',
      fetch: false,
    },
    permUserId: { initialValue: '' },
    requestPreferences: {
      type: 'okapi',
      records: 'requestPreferences',
      path: 'request-preference-storage/request-preference',
      accumulate: 'true',
      fetch: false,
    },
    patronGroups: {
      type: 'okapi',
      path: 'groups',
      records: 'usergroups',
    },
    addressTypes: {
      type: 'okapi',
      path: 'addresstypes',
      records: 'addressTypes',
    },
    /** kware start edit - Enable service points fetching for staff user creation */
    servicePoints: {
      type: 'okapi',
      path: 'service-points',
      records: 'servicepoints',
      accumulate: 'true',
      fetch: true,
    },
    /** kware end edit */
    departments: {
      type: 'okapi',
      path: 'departments',
      records: 'departments',
    },
    settings: {
      type: 'okapi',
      records: 'configs',
      path: 'configurations/entries?query=(module==USERS and configName==profile_pictures)',
    },
    permissionSets: {
      type: 'okapi',
      path: 'perms/permissions?query=type==set&length=1000',
      records: 'permissions',
    },
  });

  static propTypes = {
    stripes: PropTypes.object,
    resources: PropTypes.object,
    mutator: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    match: PropTypes.object,
  };

  render() {
    return (
      <StaffUserCreate
        {...this.props}
      />
    );
  }
}

export default stripesConnect(StaffUserCreateContainer);